import '../../../css/components/_video-modal.pcss'
import { findMany, find, on, dataset, ucwords, whenElementIsInView, off, isTouchDevice } from '../helpers';
import { GaEvent } from '../EventTracking';

const state = {
    booted: false,
    htmxBooted: false,
};

const vimeoHandle = '[data-video-channel="vimeo"]';
const youtubeHandle = '[data-video-channel="youtube"]';

const targetElements = [
    find('#tabs-vertical'),
];

// Set up Cookiebot consent variables only once
const consent = (typeof Cookiebot !== 'undefined' && Cookiebot.consent) || {};
const consentStatistics = consent.statistics;
const consentMarketing = consent.marketing;

const options = {
    youtube: {
        autoplay: 1,
        nocookie: !consentMarketing,
        playsinline: 1,
        rel: 0,
    },
    vimeo: {
        autoplay: 1,
        portrait: false,
        title: false,
        dnt: !consentStatistics,
        color: 'bccf00',
    },
};

const recordView = (button, channel) => {
    if (button.listening) {
        return false;
    }

    button.listening = true;

    const videoId = dataset(button, 'videoId');

    if (consentStatistics) {
        const videoUrl = channel === 'vimeo' ? `https://vimeo.com/${videoId}` : `https://www.youtube.com/watch?v=${videoId}`;

        on('click', () => {
            GaEvent({
                category: 'Video',
                action: ucwords(button.innerText) || 'Play',
                label: videoUrl,
            })
        }, button, true)
    }
}

const handle = async (vimeoHandle, youtubeHandle) => {
    if (!state.booted || !state.htmxBooted) {

        state.booted = true;
        state.htmxBooted = true;

        const ModalVideo = (await import(/* webpackChunkName: "video-modal-vendor" */'modal-video')).default

        new ModalVideo(vimeoHandle, {
            channel: 'vimeo',
            ...options,
        });

        new ModalVideo(youtubeHandle, {
            channel: 'youtube',
            ...options,
        });

        findMany(vimeoHandle).forEach(button => recordView(button, 'vimeo'));
        findMany(youtubeHandle).forEach(button => recordView(button, 'youtube'));
    }
}

const waitForView = () => {
    whenElementIsInView([vimeoHandle, youtubeHandle], async inView => {
        inView && handle(vimeoHandle, youtubeHandle)
    }, true)
}

const waitForHover = () => {
    findMany([vimeoHandle, youtubeHandle]).forEach(element => {
        const onHover = () => {
            handle(vimeoHandle, youtubeHandle)
            off('mouseover', onHover, element)
            off('focus', onHover, element)
        }

        on('mouseover', onHover, element);
        on('focus', onHover, element);
    })
}

if (isTouchDevice()) {
    waitForView()
} else {
    waitForHover()
}

on('htmx:afterSwap', event => {
    if (targetElements.includes(event.target)) {
        state.htmxBooted = false;
        handle('[data-htmx-video-channel="vimeo"]', '[data-htmx-video-channel="youtube"]')
    }
}, document, true);

export {
    options,
}
